import React, { useState } from 'react'

// evertel
import { Button, Checkbox, InfoBox, Modal, ModalBody, ModalFooter, ModalHeader, Text } from '@evertel/web/ui'
import { Links } from '@evertel/constants'

interface EnableConnectorModalProps {
    visible: boolean
    connectorName: string
    loading: boolean
    onClose: () => void
    onConfirm: () => void
}

const EnableConnectorModal: React.FC<EnableConnectorModalProps> = ({
    visible,
    connectorName,
    loading,
    onClose,
    onConfirm
}) => {

    const [acknowledged, setAcknowledged] = useState(false)

    const handleClose = () => {
        setAcknowledged(false)
        onClose()
    }

    const handleConfirm = () => {
        onConfirm()
        setAcknowledged(false)
    }

    return (
        <Modal
            visible={visible}
            onClose={handleClose}
            size="lg"
        >
            <ModalHeader
                title="Enable an external Connector in this room?"
            />
            <ModalBody>
                <InfoBox
                    color="warning"
                    className="mb-3"
                >
                    <strong>Content in this room will be sent to systems outside Evertel.</strong>
                    {' '}<a href={Links.helpConnectors} target="_blank" rel="noopener noreferrer" style={{color: 'currentColor', textDecoration: 'underline'}}>Learn more</a>
                </InfoBox>

                <p className="mb-2">
                    When you enable an external connector for this room, anything that is posted may be delivered to external systems. This includes:
                </p>

                <ul className="mt-3">
                    <li><strong>Messages</strong></li>
                    <li><strong>Media</strong></li>
                    <li><strong>Files</strong></li>
                    <li><strong>Shared EverDocs</strong></li>
                </ul>

                <Text color="muted" size="small">
                    Once data leaves Evertel, we cannot control access to it. Room members may not be aware that their content is being shared outside Evertel, so only enable connectors in rooms where this level of sharing is appropriate under your agency’s policies.
                </Text>

                <div className="border rounded mt-4 p-3">
                    <Checkbox
                        id="enable-connector-acknowledge"
                        name="enable-connector-acknowledge"
                        label="I understand that all content shared in this room may be sent to external systems outside Evertel."
                        checked={acknowledged}
                        onChange={() => setAcknowledged(!acknowledged)}
                    />
                </div>
            </ModalBody>
            <ModalFooter align="right">
                <Button
                    color="link"
                    outline
                    className="me-2"
                    onClick={handleClose}
                >
                    Cancel
                </Button>
                <Button
                    color="primary"
                    onClick={handleConfirm}
                    disabled={!acknowledged}
                    loading={loading}
                >
                    Enable Connector
                </Button>
            </ModalFooter>
        </Modal>
    )
}

EnableConnectorModal.displayName = 'EnableConnectorModal'

export { EnableConnectorModal }
